<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e2339867" style="color: #82a339"><b>HEARTY MUSHROOM-BARLEY SOUP</b></p>
<p class="ext" id="d7e2340367"><b><i>A real rib-sticker. Get a head start by cooking the barley the day before, then cool and refrigerate until needed.</i></b></p>
<p class="h4" id="d7e2341367" style="color: #496210"><b>Prep: 20 minutes Cook: 1 hour</b></p>
<p class="ul" id="d7e2341967">¾ cup pearl barley</p>
<p class="ul" id="d7e2342867">8 cups water</p>
<p class="ul" id="d7e2343167">2 tablespoons olive oil</p>
<p class="ul" id="d7e2343467">3 stalks celery, cut into ¼-inch-thick slices</p>
<p class="ul" id="d7e2344667">1 large onion (12 ounces), chopped</p>
<p class="ul" id="d7e2344967">1½ pounds mushrooms, trimmed and thickly sliced</p>
<p class="ul" id="d7e2346367">2 tablespoons tomato paste</p>
<p class="ul" id="d7e2346667">5 carrots, peeled and each cut lengthwise in half, <br/> then crosswise into ¼-inch-thick slices</p>
<p class="ul" id="d7e2348167">2 cans (14½ ounces each) beef broth or</p>
<p class="ul" id="d7e2349267">3½ cups Brown Beef Stock</p>
<p class="ul" id="d7e2350467">¼ cup dry sherry</p>
<p class="ul" id="d7e2351367">1½ teaspoons salt</p>
<p class="pub" id="d7e2352767" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In 3-quart saucepan, combine barley and 4 cups water; heat to boiling over high heat. Reduce heat; cover and simmer 30 minutes. Drain.</p>
<p class="pub" id="d7e2354067"><span style="color: #c15b49"><b>2.</b></span> Meanwhile, in 5-quart Dutch oven, heat oil over medium-high heat. Add celery and onion; cook, stirring, until golden, about 10 minutes. Increase heat to high; add mushrooms and cook, stirring occasionally, until liquid has evaporated and mushrooms are lightly browned, 10 to 12 minutes.</p>
<p class="pub" id="d7e2356667"><span style="color: #c15b49"><b>3.</b></span> Reduce heat to medium-high; add tomato paste and cook, stirring, 2 minutes. Add barley, carrots, broth, sherry, salt, and remaining 4 cups water; heat to boiling. Reduce heat; cover and simmer until carrots and barley are tender, 20 to 25 minutes. Makes about 12 cups or 10 first-course servings.</p>
<p class="ntx" id="d7e2359167">Each serving: About 133 calories, 5g protein, 21g carbohydrate, 4g total fat (1g saturated), 1mg cholesterol, 684mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c70_r1.vue?fd4c41e4